import {API} from 'aws-amplify';

export const read = async () => API.get('eventmanagerUserApi', '/guests', {});

export const readOne = async (id) => API.get('eventmanagerUserApi', `/guests/${id}`, {});

export const create = async (guest) => API.put('eventmanagerUserApi', `/guests`, {body: guest});

export const update = async (guest) => API.post('eventmanagerUserApi', `/guests`, {body: guest});

export const del = async (id) => API.del('eventmanagerUserApi', `/guests/${id}`, {});
